import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchQueryChangeLogsFile = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("patient_id", patientId);
  params.append("trial_id", trialId);

  const response = await axios.get(
    `${__API_URL__}/api/ecrf/get_query_change_logs_file/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetQueryChangeLogsFile = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["query_change_logs_file", patientId, trialId],
    queryFn: () => fetchQueryChangeLogsFile({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
    refetchOnWindowFocus: false,
  });
};

export default useGetQueryChangeLogsFile;
